<div class="headingHolder">
    <h2 [innerHTML]="headerTitle"></h2>
    <p [innerHTML]="desc"></p>    
    <hr *ngIf="shariahMasterclassBlock" class="watchOnlineVideoHr" />
</div>